/*
* fn: 深度解析JSON字符串
* params: str
* return: obj or str
*/
export function deepJsonParse (str) {
  if (str === null || str === 'null' || str === 'undefined') {
    return null
  }
  if (isJsonString(str)) {
    const res = JSON.parse(str)
    Object.keys(res).forEach(key => {
      res[key] = deepJsonParse(res[key])
    })
    return res
  } else {
    return str
  }
}
// 函数功能：判断一个字符串是否是JSON字符串
export function isJsonString (str) {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true
    }
  } catch (e) {
  }
  return false
}
